import React, { useState } from 'react'
import { FaAngleLeft } from "react-icons/fa6";
import { useLocation, useNavigate } from 'react-router';
import { IoSearchSharp } from "react-icons/io5";

const Search = () => {
    const navigation = useNavigate();
    const [name,setName]=useState("")
    return (
        <div style={{padding: "0px 20px"}}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    maxWidth: "770px",
                    margin: "auto"
                }}
            >
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                    <FaAngleLeft onClick={() => navigation(-1)} />
                </div>
                <input
                    type="text"
                    placeholder="Search for restaurants"
                    style={styles.input}
                    value={name}
                    onChange={(e) => {
                        setName(e.target.value);
                    }}
                />
                <IoSearchSharp />
            </div>
        </div>
    )
}

const styles = {
    input: {
        width: '100%',
        padding: '10px',
        borderRadius: '5px',
        border: "none",
        fontSize: '16px',
        outline: "none",
    },
   
};

export default Search
